import { MerchandiseOrderCreationItem } from 'api/order'
import getMerchandiseItemViews from 'checkout/selectors/view/itemViews/getMerchandiseItemViews'
import { createSelector } from 'reselect'

const getFormattedMerchandiseItems = createSelector(
  (state: App.State) => getMerchandiseItemViews(state),
  (views): Array<MerchandiseOrderCreationItem> => {
    return views.data.map((view): MerchandiseOrderCreationItem => {
      return {
        type: 'merchandise',
        transaction_key: view.item.transactionKey,
        total: view.totals.price,
        shippingGroup: view.item.shippingId!,
        variantId: view.item.variantId,
      }
    })
  })

export default getFormattedMerchandiseItems
